const BYTE_UNITS = ['B', 'KB', 'MB', 'GB'];

export const formatBytes = (bytes: number) => {
  let value = bytes;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < BYTE_UNITS.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  const rounded = unitIndex === 0 ? value : Math.round(value * 100) / 100;

  return `${rounded} ${BYTE_UNITS[unitIndex]}`;
};
